export function expiryStatus(expiry, warnDays = 7) {
  if (!expiry) return { key: "none", label: "Senza data", days: null };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(expiry);
  if (isNaN(d.getTime())) return { key: "none", label: "Senza data", days: null };
  d.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { key: "expired", label: `Scaduto da ${Math.abs(days)}g`, days };
  if (days === 0) return { key: "soon", label: "Scade oggi", days };
  if (days <= warnDays) return { key: "soon", label: `Scade tra ${days}g`, days };
  return { key: "ok", label: `Tra ${days} giorni`, days };
}

export function alertCount(items, warnDays = 7) {
  return (items || []).filter((i) => {
    const k = expiryStatus(i.expiry, warnDays).key;
    return k === "expired" || k === "soon";
  }).length;
}

export const STATUS_STYLE = {
  expired: "bg-red-100 text-red-700 border-red-200",
  soon: "bg-amber-100 text-amber-700 border-amber-200",
  ok: "bg-emerald-100 text-emerald-700 border-emerald-200",
  none: "bg-slate-100 text-slate-500 border-slate-200",
};
